import default_config from "./helpers/default_config";
import env from "../../tools/Environment";
class AuthServiceConfig {
  /**
   * Project should provide custom config, but default config always there.
   * (You'll receive console error if you don't provide custom config)
   * Custom config params are more important than default config params (and overwrite them).
   * Also, we have common section in both (default and custom) configs.
   * So, priority order looks like this: common default < territory default < common custom < territory custom
   * @param {object} config
   * @param {string} territory
   * @param {string} auth_method authorization method, now we are using only oauth method
   */
  constructor(config = null, territory = env.getTerritory(), auth_method = "oauth") {
    //set default territory if we don't have one; basically it's a hack.
    // It turned out that this config has already initialized before correct envs are ready.
    // It affects  nuxt projects which don't support new territory configs with process.env.
    if (!territory) {
      territory = env.MYGAMES;
    }
    // merge common custom section and territory custom section; territory section has a priority
    const merged_default_config = this._prepareConfig(default_config, territory, auth_method);
    if (config !== null) {
      const merged_main_config = this._prepareConfig(config, territory, auth_method);
      this.config = Object.assign({}, merged_default_config, merged_main_config);
    } else {
      console.error(
        "You have to provide auth service config. App is continuing to execute using default config only"
      );
      this.config = merged_default_config;
    }
  }
  _prepareConfig(config, territory, auth_method) {
    const territory_config = config[auth_method][territory];
    const common_config = config[auth_method].common;
    return Object.assign({}, common_config, territory_config);
  }
  setStore(store) {
    this.config.store = store;
  }
  setApi(api) {
    this.config.api = api;
  }

  /**
   * It's for dynamic bind store and api
   * @param store
   * @param api
   */
  setDynamicParams({ store, api }) {
    this.setStore(store);
    this.setApi(api);
  }

  setConfigSection(name, value) {
    this.config = Object.assign({}, this.config, { [name]: value });
  }
  replaceConfigSection(name, value) {
    if (this.config[name]) {
      this.setConfigSection(name, value);
    }
  }

  /**
   * Set social ep list
   * @param {[string]} list
   */
  setSocialEpList(list) {
    this.replaceConfigSection("social_ep_list", list);
  }

  /**
   * Set custom profile fields
   * @param {[string]} fields
   */
  setProfileFields(fields) {
    this.replaceConfigSection("profile_fields", fields);
  }

  getConfig() {
    return this.config;
  }

  /**
   * check store and api
   * @returns {boolean}
   */
  isConfigValid() {
    return !!(this.config.store && this.config.api);
  }
}
export default AuthServiceConfig;
